module.exports = __webpack_public_path__ + "img/code.6a3213a8.svg";